import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=21d956c4&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d956c4')) {
      api.createRecord('21d956c4', component.options)
    } else {
      api.reload('21d956c4', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=21d956c4&", function () {
      api.rerender('21d956c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Slider/Slider.vue"
export default component.exports